<template>
  <svg width="60" height="24" viewBox="0 0 60 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g id="voice-1">
      <rect
        :y="12 - getBarHeight(0.3)"
        :height="getBarHeight(0.3) * 2"
        :opacity="getBarOpacity(0.3)"
        x="0"
        width="4"
        rx="2"
        fill="#1C74DA"
      />
      <rect
        :y="12 - getBarHeight(0.5)"
        :height="getBarHeight(0.5) * 2"
        :opacity="getBarOpacity(0.5)"
        x="8"
        width="4"
        rx="2"
        fill="#1C74DA"
      />
      <rect
        :y="12 - getBarHeight(0.9)"
        :height="getBarHeight(0.9) * 2"
        :opacity="getBarOpacity(0.9)"
        x="16"
        width="4"
        rx="2"
        fill="#1C74DA"
      />
      <rect
        :y="12 - getBarHeight(0.7)"
        :height="getBarHeight(0.7) * 2"
        :opacity="getBarOpacity(0.7)"
        x="24"
        width="4"
        rx="2"
        fill="#1C74DA"
      />
      <rect
        :y="12 - getBarHeight(1.0)"
        :height="getBarHeight(1.0) * 2"
        :opacity="getBarOpacity(1.0)"
        x="32"
        width="4"
        rx="2"
        fill="#1C74DA"
      />
      <rect
        :y="12 - getBarHeight(0.8)"
        :height="getBarHeight(0.8) * 2"
        :opacity="getBarOpacity(0.8)"
        x="40"
        width="4"
        rx="2"
        fill="#1C74DA"
      />
      <rect
        :y="12 - getBarHeight(0.6)"
        :height="getBarHeight(0.6) * 2"
        :opacity="getBarOpacity(0.6)"
        x="48"
        width="4"
        rx="2"
        fill="#1C74DA"
      />
      <rect
        :y="12 - getBarHeight(0.7)"
        :height="getBarHeight(0.7) * 2"
        :opacity="getBarOpacity(0.7)"
        x="56"
        width="4"
        rx="2"
        fill="#1C74DA"
      />
    </g>

    <g id="voice-2">
      <rect
        :y="12 - getBarHeight(0.5)"
        :height="getBarHeight(0.5) * 2"
        :opacity="getBarOpacity(0.5)"
        x="0"
        width="4"
        rx="2"
        fill="#1C74DA"
      />
      <rect
        :y="12 - getBarHeight(0.4)"
        :height="getBarHeight(0.4) * 2"
        :opacity="getBarOpacity(0.4)"
        x="8"
        width="4"
        rx="2"
        fill="#1C74DA"
      />
      <rect
        :y="12 - getBarHeight(0.7)"
        :height="getBarHeight(0.7) * 2"
        :opacity="getBarOpacity(0.7)"
        x="16"
        width="4"
        rx="2"
        fill="#1C74DA"
      />
      <rect
        :y="12 - getBarHeight(1.0)"
        :height="getBarHeight(1.0) * 2"
        :opacity="getBarOpacity(1.0)"
        x="24"
        width="4"
        rx="2"
        fill="#1C74DA"
      />
      <rect
        :y="12 - getBarHeight(0.9)"
        :height="getBarHeight(0.9) * 2"
        :opacity="getBarOpacity(0.9)"
        x="32"
        width="4"
        rx="2"
        fill="#1C74DA"
      />
      <rect
        :y="12 - getBarHeight(0.6)"
        :height="getBarHeight(0.6) * 2"
        :opacity="getBarOpacity(0.6)"
        x="40"
        width="4"
        rx="2"
        fill="#1C74DA"
      />

      <rect
        :y="12 - getBarHeight(0.2)"
        :height="getBarHeight(0.2) * 2"
        :opacity="getBarOpacity(0.2)"
        x="48"
        width="4"
        rx="2"
        fill="#1C74DA"
      />

      <rect
        :y="12 - getBarHeight(0.3)"
        :height="getBarHeight(0.3) * 2"
        :opacity="getBarOpacity(0.3)"
        x="56"
        width="4"
        rx="2"
        fill="#1C74DA"
      />
    </g>
    <g id="voice-3">
      <rect
        :y="12 - getBarHeight(0.5)"
        :height="getBarHeight(0.5) * 2"
        :opacity="getBarOpacity(0.5)"
        x="0"
        width="4"
        rx="2"
        fill="#1C74DA"
      />

      <rect
        :y="12 - getBarHeight(0.3)"
        :height="getBarHeight(0.3) * 2"
        :opacity="getBarOpacity(0.3)"
        x="8"
        width="4"
        rx="2"
        fill="#1C74DA"
      />
      <rect
        :y="12 - getBarHeight(0.6)"
        :height="getBarHeight(0.6) * 2"
        :opacity="getBarOpacity(0.6)"
        x="16"
        width="4"
        rx="2"
        fill="#1C74DA"
      />
      <rect
        :y="12 - getBarHeight(0.9)"
        :height="getBarHeight(0.9) * 2"
        :opacity="getBarOpacity(0.9)"
        x="24"
        width="4"
        rx="2"
        fill="#1C74DA"
      />
      <rect
        :y="12 - getBarHeight(0.8)"
        :height="getBarHeight(0.8) * 2"
        :opacity="getBarOpacity(0.8)"
        x="32"
        width="4"
        rx="2"
        fill="#1C74DA"
      />

      <rect
        :y="12 - getBarHeight(1.0)"
        :height="getBarHeight(1.0) * 2"
        :opacity="getBarOpacity(1.0)"
        x="40"
        width="4"
        rx="2"
        fill="#1C74DA"
      />

      <rect
        :y="12 - getBarHeight(0.5)"
        :height="getBarHeight(0.5) * 2"
        :opacity="getBarOpacity(0.5)"
        x="48"
        width="4"
        rx="2"
        fill="#1C74DA"
      />

      <rect
        :y="12 - getBarHeight(0.5)"
        :height="getBarHeight(0.5) * 2"
        :opacity="getBarOpacity(0.5)"
        x="56"
        width="4"
        rx="2"
        fill="#1C74DA"
      />
    </g>
  </svg>
</template>

<script>
export default {
  name: 'VoiceAnimation',
  props: {
    audioLevel: {
      type: Number,
      required: false,
      default: 0, // 0 to 1
    },
  },
  computed: {
    /**
     * Smoothed audio level with decay for more natural animation
     */
    smoothedLevel() {
      // Add minimum baseline so animation is never completely flat
      const baseline = 0.2 // Very small baseline when silent
      return baseline + this.audioLevel * (1 - baseline)
    },
  },
  methods: {
    /**
     * Calculate bar height based on audio level and bar multiplier
     * @param {number} multiplier - How much this bar should respond (0-1)
     * @returns {number} Height in pixels
     */
    getBarHeight(multiplier) {
      const minHeight = 2 // Minimum height when silent
      const maxHeight = 10 // Maximum height when speaking loudly
      const height = minHeight + this.smoothedLevel * multiplier * (maxHeight - minHeight)
      return Math.max(minHeight, height)
    },

    /**
     * Calculate bar opacity based on audio level
     * @param {number} multiplier - How much this bar should respond (0-1)
     * @returns {number} Opacity value (0-1)
     */
    getBarOpacity(multiplier) {
      const minOpacity = 0.15 // Very low opacity when silent
      const maxOpacity = 1.0 // Maximum opacity when speaking
      return minOpacity + this.smoothedLevel * multiplier * (maxOpacity - minOpacity)
    },
  },
}
</script>

<style lang="scss" scoped>
#voice-1 {
  animation: 0.25s linear 1s infinite alternate show;
}

#voice-2 {
  animation: 0.25s linear 1s infinite alternate show;
  animation-delay: 0.25s;
}

#voice-3 {
  animation: 0.25s linear 1s infinite alternate show;
  animation-delay: 0.25s;
}

svg {
  rect {
    transition: all 0.1s ease-out;
  }
}

@keyframes show {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}
</style>
